import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  role: "alert"
}

import {captureOperationFeedback} from '@/utils/operationFeedback'
import {automaticAvailable,automaticPresented,automaticClosed} from '@/utils/automaticNotices'


import {computed,ref,watch,onBeforeUnmount,onMounted} from 'vue'
import {claimPopup,popupAvailable,releasePopup} from '@/utils/popupDisplay'
import AdminNoticeCard from '@/components/AdminNoticeCard.vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import {adminNoticeBlocking,adminNoticeVisit} from '@/utils/adminNoticeRuntime'

export default /*#__PURE__*/_defineComponent({
  __name: 'BranchAdminNotice',
  props: {
    channel: {},
    ready: { type: Boolean, default: true },
    entryPlacement: { default: 'floating' }
  },
  setup(__props: any) {

const popupOwner={}
const props=__props,route=useRoute()
const eligible=ref(false),items=ref<any[]>([]),notice=ref<any>(null),expanded=ref(false),busy=ref(false),error=ref(''),inboxError=ref(''),inboxVisible=ref(false),inboxWidth=ref(420)
let serial=0,loadSerial=0,viewSerial=0,disposed=false,checking=false,attempted='',poll:ReturnType<typeof setInterval>|undefined
const orgId=computed(()=>Number(props.channel==='admin'?store.getters.userInfo?.orgId:store.getters.orgId))
const identity=computed(()=>store.getters.token && store.getters.userInfo?.id && props.ready!==false && orgId.value>1000?JSON.stringify([store.getters.token,orgId.value,store.getters.userInfo.id,store.getters.userInfo.orgId,store.getters.userInfo.roleId]):'')
const unconfirmed=computed(()=>items.value.filter(n=>!n.confirmed).length)
function safe(){return popupAvailable(popupOwner,'private-admin-notice-shell') && document.visibilityState!=='hidden' && !/pay|orderconfirm|upgrade|deposite|login|request|upload|edit|[/]add/i.test(route.path) && !Array.from(document.querySelectorAll('.ant-modal-wrap:not(.private-admin-notice-shell), .ant-drawer-open')).some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden') && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')}
function resize(){inboxWidth.value=Math.min(440,window.innerWidth)}
async function api(method:'GET'|'POST',path:string,data?:any){const result=await request({url:(props.channel==='admin'?'branchAdminNotices':'customer/branchAdminNotices')+path,method,params:props.channel==='web'?{orgId:orgId.value,channel:'web'}:undefined,data,quietNotification:true} as any);return result.data}
function invalidateView(){serial++;loadSerial++;viewSerial++;checking=false;busy.value=false;notice.value=null;inboxVisible.value=false;inboxError.value='';error.value='';expanded.value=false;adminNoticeBlocking.value=false}
function reset(){invalidateView();items.value=[];eligible.value=false;attempted=''}
function closeInbox(){viewSerial++;inboxVisible.value=false}
function dismiss(){if(busy.value)return;viewSerial++;notice.value=null;expanded.value=false;error.value='';adminNoticeBlocking.value=false}
async function load(){const who=identity.value,ticket=serial,loadRun=++loadSerial;if(!who)return false;const response=await api('GET','/inbox');if(disposed || ticket!==serial || loadRun!==loadSerial || who!==identity.value)return false;eligible.value=response?.eligible===true;items.value=eligible.value && Array.isArray(response.items)?response.items:[];if(notice.value && !notice.value.confirmed){const current=items.value.find(n=>n.id===notice.value.id && n.version===notice.value.version);if(!current || current.confirmed){notice.value=null;expanded.value=false;adminNoticeBlocking.value=false}}if(!eligible.value)invalidateView();return eligible.value}
async function check(){
 if(checking || disposed || !identity.value)return
 const who=identity.value,ticket=serial,viewRun=viewSerial,visit=adminNoticeVisit(who);checking=true;adminNoticeBlocking.value=true
 try{
  if(!await load() || viewRun!==viewSerial || notice.value || attempted===visit || !automaticAvailable('admin') || !safe())return
  if(!claimPopup(popupOwner,'private-admin-notice-shell'))return
  attempted=visit;const value=await api('POST','/claim',{visit})
  if(disposed || ticket!==serial || who!==identity.value || viewRun!==viewSerial || !eligible.value || !safe() || !value?.id)return
  notice.value=value;automaticPresented('admin');expanded.value=false;error.value='';await api('POST','/'+value.id+'/'+value.version+'/shown')
 }catch{/* 服务未启用或权限不符时保持关闭，不干扰浏览。 */}
 finally{if(ticket===serial && who===identity.value){checking=false;if(!notice.value){adminNoticeBlocking.value=false;releasePopup(popupOwner)}}}
}
async function action(action:string){const current=notice.value,who=identity.value,ticket=serial;if(!current || busy.value)return null;busy.value=true;error.value='';try{const value=await api('POST','/'+current.id+'/'+current.version+'/'+action);if(disposed || ticket!==serial || who!==identity.value || current!==notice.value)return null;notice.value=value;return value}catch(e:any){if(ticket===serial && who===identity.value){error.value=e?.message || '操作未成功，请稍后重试'}return null}finally{if(ticket===serial && who===identity.value)busy.value=false}}
async function view(){const ticket=serial,who=identity.value,viewRun=viewSerial;if(await action('view') && ticket===serial && who===identity.value && viewRun===viewSerial)expanded.value=true}
async function confirm(){if(notice.value)automaticClosed();const reportOperationIssue=captureOperationFeedback();const ticket=serial,who=identity.value,viewRun=viewSerial;if(await action('confirm') && ticket===serial && who===identity.value && viewRun===viewSerial){notice.value=null;adminNoticeBlocking.value=false;void load().catch(()=>{if(ticket===serial && who===identity.value){inboxError.value='通知列表暂时无法更新，请稍后重试';reportOperationIssue(inboxError.value)}})}}
async function openInbox(){const reportOperationIssue=captureOperationFeedback();
 if(busy.value)return
 const ticket=serial,who=identity.value,viewRun=++viewSerial;inboxError.value=''
 try{if(await load() && !disposed && ticket===serial && who===identity.value && viewRun===viewSerial){inboxVisible.value=true;notice.value=null;adminNoticeBlocking.value=false}}
 catch{if(ticket===serial && who===identity.value && viewRun===viewSerial){inboxError.value='通知暂时无法读取，请稍后重试';reportOperationIssue(inboxError.value)}}
}
async function openItem(item:any){const reportOperationIssue=captureOperationFeedback();
 if(busy.value)return
 const who=identity.value,ticket=serial,viewRun=++viewSerial;inboxError.value=''
 try{const value=await api('POST','/'+item.id+'/'+item.version+'/view');if(disposed || ticket!==serial || who!==identity.value || viewRun!==viewSerial)return;inboxVisible.value=false;notice.value=value;expanded.value=true;adminNoticeBlocking.value=true}
 catch(e:any){if(ticket===serial && who===identity.value && viewRun===viewSerial){inboxError.value=e?.message || '通知已更新或停止展示，请刷新';reportOperationIssue(inboxError.value)}}
}
function visibility(){if(document.visibilityState==='hidden')invalidateView();else if(identity.value){adminNoticeVisit(identity.value,true);attempted='';void check()}}
let privateShownAs=''
watch(notice,(value,old)=>{if(value)privateShownAs=identity.value;else{if(old&&privateShownAs===identity.value)automaticClosed();privateShownAs='';releasePopup(popupOwner)}},{flush:'sync'})
watch(identity,()=>{reset();if(identity.value){adminNoticeBlocking.value=true;void check()}},{immediate:true})
watch(()=>route.path,()=>{invalidateView();void check()})
onMounted(()=>{resize();window.addEventListener('resize',resize);document.addEventListener('visibilitychange',visibility);poll=setInterval(()=>{if(notice.value)void load().catch(()=>{/* 保留现有浏览状态，下一轮重试。 */});else void check()},4000)})
onBeforeUnmount(()=>{disposed=true;reset();releasePopup(popupOwner);clearInterval(poll);window.removeEventListener('resize',resize);document.removeEventListener('visibilitychange',visibility)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (eligible.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["admin-notice-entry", {'admin-notice-entry-header':props.entryPlacement==='header'}]),
          onClick: openInbox
        }, [
          _createTextVNode("管理员通知"),
          (unconfirmed.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " · " + _toDisplayString(unconfirmed.value), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: !!notice.value,
      footer: null,
      closable: false,
      "mask-closable": false,
      width: 440,
      centered: "",
      "wrap-class-name": "private-admin-notice-shell",
      "body-style": {padding:'0',background:'transparent'},
      onCancel: dismiss
    }, {
      default: _withCtx(() => [
        (notice.value)
          ? (_openBlock(), _createBlock(AdminNoticeCard, {
              key: 0,
              notice: notice.value,
              expanded: expanded.value,
              busy: busy.value,
              error: error.value,
              onLater: dismiss,
              onView: view,
              onConfirm: confirm
            }, null, 8, ["notice", "expanded", "busy", "error"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "private-admin-notice-close",
          "aria-label": "稍后处理管理员通知",
          disabled: busy.value,
          onClick: dismiss
        }, "×", 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      visible: inboxVisible.value && eligible.value,
      title: "管理员专属通知",
      width: inboxWidth.value,
      onClose: closeInbox
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          type: "info",
          "show-icon": "",
          message: "仅分店管理员可见，员工和普通客户不可见。"
        }),
        (!items.value.length)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 0,
              description: "暂无管理员专属通知"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.id+':'+item.version,
            class: "private-admin-notice-row",
            type: "button",
            onClick: ($event: any) => (openItem(item))
          }, [
            _createElementVNode("strong", null, _toDisplayString(item.title), 1),
            _createElementVNode("span", null, _toDisplayString(item.important?'重要 · ':'') + _toDisplayString(item.confirmed?'已确认收到':'待确认') + " 查看 ›", 1)
          ], 8, _hoisted_3))
        }), 128)),
        (inboxError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(inboxError.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "width"])
  ], 64))
}
}

})